import { TrendingDown, TrendingUp } from "lucide-react";

import { Badge } from "@/shared/ui/badge";
import { Card, CardContent } from "@/shared/ui/card";

import type { RemeasureResult } from "../../api/bizAdvisorService";

const MULTIPLIER_LABEL: Record<string, string> = {
  traffic: "流量",
  conversion: "转化",
  aov: "客单价",
  repurchase: "复购",
  viral: "口碑转介绍",
};

function fmt(n: number | null): string {
  return n == null ? "—" : String(n);
}

/** 复测对比卡:锚此次诊断被派的乘子,展示 before→after + delta(正绿负红)。 */
export function RemeasureDeltaCard({ result }: { result: RemeasureResult }) {
  if (!result.deltas.length) return null;
  return (
    <Card>
      <CardContent className="space-y-3 p-6">
        <div className="text-sm font-medium">复测对比(锚此次诊断派单的乘子)</div>
        <div className="space-y-2">
          {result.deltas.map((d) => {
            const up = (d.delta ?? 0) > 0;
            const down = (d.delta ?? 0) < 0;
            return (
              <div
                key={d.playKey}
                className="flex items-center justify-between rounded-md border px-3 py-2 text-sm"
              >
                <Badge variant="outline">{MULTIPLIER_LABEL[d.playKey] ?? d.playKey}</Badge>
                <div className="flex items-center gap-3 tabular-nums">
                  <span className="text-muted-foreground">
                    {fmt(d.before)} → {fmt(d.after)}
                  </span>
                  <span
                    className={
                      up
                        ? "flex items-center gap-1 font-medium text-emerald-600"
                        : down
                          ? "flex items-center gap-1 font-medium text-rose-600"
                          : "text-muted-foreground"
                    }
                  >
                    {up && <TrendingUp className="h-3.5 w-3.5" />}
                    {down && <TrendingDown className="h-3.5 w-3.5" />}
                    {d.delta == null ? "—" : `${up ? "+" : ""}${d.delta}`}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
